import { z } from 'zod'

import { AreaTicketIndicatorsResponsible } from './ResponsibleTicketIndicators'
import { SlaMetrics } from './SlaMetrics'

export const AreaTicketIndicators = z.object({
  pendingCount: z.number(),
  totalTickets: z.number(),
  totalCompleted: z.number(),
  completionPercentage: z.number(),
  csat: z.number().nullish(),
  star: z.number().nullish(),
  averageResponseTime: z.string(),
  sla: z.array(SlaMetrics),
  averageCompletionTime: z.string(),
  inAnalysisCount: z.number(),
  waitingForAnalysisCount: z.number(),
  completedCount: z.number()
})

export const CreateTicketIndicatorsDTO = AreaTicketIndicatorsResponsible.omit({
  responsibleId: true
})
export type CreateTicketIndicatorsDTO = z.infer<
  typeof AreaTicketIndicatorsResponsible
>
export type AreaTicketIndicators = z.infer<typeof AreaTicketIndicators>
